/*
 * Lorenzo Pagani CRO preview.
 * Loaded only by the unpublished Shopify draft theme.
 */
(() => {
  const preferredNames = {
  "lorenzo-pagani-velocite": "Aéroligne Chronograph",
  "lorenzo-pagani-magnolia": "Émeraude 32",
  "lorenzo-pagani-regent": "Océanique Planétaire 42",
  "lorenzo-pagani-souverain": "Orbital Skeleton",
  "lorenzo-pagani-circuit": "Octave Offshore Chronograph",
  "lorenzo-pagani-vendome": "Patrimoine Sport Chronograph",
  "lorenzo-pagani-beaubourg": "Nautique Chronograph",
  "lorenzo-pagani-concorde": "Rive Gauche Small Seconds",
  "lorenzo-pagani-palatin": "Héritage Diver 40",
  "lorenzo-pagani-brasier": "Héritage Racing Chronograph",
  "lorenzo-pagani-voyageur": "Céleste Dual Time",
  "lorenzo-pagani-belvedere": "Alpine Diver 43",
  "lorenzo-pagani-diademe": "Orbital Twin Tourbillon",
  "lorenzo-pagani-monarque": "Mécanique Twin Balance",
  "lorenzo-pagani-piston": "Aviateur Chronograph 44",
  "lorenzo-pagani-sorbonne": "Vélocité Ceramic Chronograph 40",
  "lorenzo-pagani-noblesse": "Atelier Automatic 40",
  "lorenzo-pagani-rotonde": "Lusitano Chronograph 41",
  "lorenzo-pagani-capitole": "Astrale Complication",
  "lorenzo-pagani-montparnasse": "Atelier Texturé Automatic 40",
  "lorenzo-pagani-florentine": "Vendôme Date 40",
  "lorenzo-pagani-tempete": "Lunaire Circuit Chronograph",
  "lorenzo-pagani-versailles": "Océanique Diver 300",
  "lorenzo-pagani-bellini": "Circuit Tonneau Chronograph",
  "lorenzo-pagani-lutece": "Avenue Automatic 37",
  "lorenzo-pagani-saphir-royale": "Atelier Square Automatic",
  "lorenzo-pagani-doge": "Nautique Open Heart 42",
  "lorenzo-pagani-prisma-course": "Vélocité Spectrum Chronograph",
  "lorenzo-pagani-etoile": "Chemin de Fer Automatic 38",
  "lorenzo-pagani-colonnade": "Couronnement Complete Calendar",
  "lorenzo-pagani-maesta": "Héritage Lagoon Diver 42",
  "lorenzo-pagani-sillage": "Vélocité Sport Chronograph",
  "lorenzo-pagani-carillon": "Balance Ouverte Automatic",
  "lorenzo-pagani-clementine": "Céleste Moonphase",
  "lorenzo-pagani-fulminant": "Mécanique Racing Chronograph",
  "lorenzo-pagani-aristide": "Mécanique Skeleton Automatic",
  "lorenzo-pagani-bourbon": "Vélocité Skeleton Automatic",
  "lorenzo-pagani-sacre": "Mécanique Tourbillon 40",
  "lorenzo-pagani-verdoyer": "Lunaire Heritage Chronograph",
  "lorenzo-pagani-palazzo": "Circuit Tonneau Skeleton",
  "lorenzo-pagani-abysse": "Vendôme Date 41",
  "lorenzo-pagani-maree": "Héritage Rivet Diver 40",
  "lorenzo-pagani-apogee": "Astrale Open Heart",
  "lorenzo-pagani-fuseau": "Expédition GMT 39",
  "lorenzo-pagani-apex": "Lusitano Régulateur Chronograph",
  "lorenzo-pagani-saphira": "Vendôme Joaillerie Chronograph",
  "lorenzo-pagani-cadence": "Aviateur Chronograph 38",
  "lorenzo-pagani-solferino": "Patrimoine Date 40",
  "lorenzo-pagani-citadelle": "Patrimoine Automatic 43",
  "lorenzo-pagani-emeraude": "Nautique Moonphase",
  "lorenzo-pagani-boreal": "Cartographe World Time GMT",
  "lorenzo-pagani-medicis": "Héritage Small Seconds",
  "lorenzo-pagani-aragon": "Songe Lunaire Automatic",
  "lorenzo-pagani-pavillon": "Grande Seconde 40",
  "lorenzo-pagani-brasero": "Circuit Glassbox Chronograph",
  "lorenzo-pagani-fougue": "Héritage Seventies Chronograph",
  "lorenzo-pagani-sprint": "Lusitano Textile Chronograph",
  "lorenzo-pagani-trajectoire": "Trajectoire Chronograph",
  "lorenzo-pagani-recif": "Cartographe GMT 40",
  "lorenzo-pagani-chatelet": "Couronnement Day-Date 40",
  "lorenzo-pagani-richelieu": "Patrimoine Sport Automatic",
  "lorenzo-pagani-turenne": "Vélocité Spectrum Chronograph 44",
  "lorenzo-pagani-lagon": "Pacifique Automatic 45",
  "lorenzo-pagani-diamantine": "Circuit Joaillerie Tonneau",
  "lorenzo-pagani-etincelle": "Circuit Tonneau Skeleton 39",
  "lorenzo-pagani-saint-honore": "Circuit Tonneau Skeleton 41",
  "lorenzo-pagani-regalia": "Héritage Rivet Diver 42",
  "lorenzo-pagani-tropique": "Expédition GMT 40",
  "lorenzo-pagani-couronne": "Régate Date 40",
  "lorenzo-pagani-tourmaline": "Aviateur Bicompax 38",
  "lorenzo-pagani-aurelio": "Octave Offshore Skeleton",
  "lorenzo-pagani-ondine": "Marina Automatic 41",
  "lorenzo-pagani-caspienne": "Horloger Diver Tourbillon",
  "lorenzo-pagani-bolide": "Grand Régulateur Chronograph 41",
  "lorenzo-pagani-sirene": "Nautique Tactical Diver",
  "lorenzo-pagani-adriano": "Orbital Diver Automatic",
  "lorenzo-pagani-galliera": "Régate Day-Date 40",
  "lorenzo-pagani-profond": "Éclat Sport Automatic 40",
  "lorenzo-pagani-triton": "Marina Skeleton Automatic",
  "lorenzo-pagani-esplanade": "Marée Diver 42",
  "lorenzo-pagani-noctis-course": "Vélocité Ceramic Chronograph",
  "lorenzo-pagani-dore-circuit": "Vélocité Prestige Chronograph",
  "lorenzo-pagani-granducale": "Circuit Tonneau Skeleton 42",
  "lorenzo-pagani-cordoban": "Marée Professional 42",
  "lorenzo-pagani-tachymetre": "Rive Gauche Chronograph",
  "lorenzo-pagani-vincennes": "Rive Gauche Automatic",
  "lorenzo-pagani-elan": "Héritage Panda Chronograph",
  "lorenzo-pagani-ressac": "Lusitano Bicompax 41",
  "lorenzo-pagani-seraphine": "Aviateur Classic 36",
  "lorenzo-pagani-corallo": "Océanique Heritage 300",
  "lorenzo-pagani-lavande": "Aviateur Heritage 38",
  "lorenzo-pagani-topaze": "Vélocité Tachymeter Chronograph",
  "lorenzo-pagani-capodimonte": "Éclat Sport 40",
  "lorenzo-pagani-marquise": "Nautique Automatic 40",
  "lorenzo-pagani-hortensia": "Couronnement Day-Date 36",
  "lorenzo-pagani-zenith": "Méridien World GMT",
  "lorenzo-pagani-cartographe": "Méridien Cartographe GMT",
  "lorenzo-pagani-orchidee": "Éclaireur Automatic 36",
  "lorenzo-pagani-mesange": "Éclat Automatic 36",
  "lorenzo-pagani-brindille": "Avenue Joaillerie",
  "lorenzo-pagani-nacre": "Vélocité Joaillerie Chronograph",
  "lorenzo-pagani-clarte": "Minimaliste 36",
  "lorenzo-pagani-frontenac": "Patrimoine Skeleton",
  "lorenzo-pagani-onda": "Patrimoine Small Seconds",
  "lorenzo-pagani-maestrale": "Océanique Diver 42",
  "lorenzo-pagani-imperial": "Héritage Rivet Automatic",
  "lorenzo-pagani-concertino": "Vélocité Skeleton Chronograph",
  "lorenzo-pagani-profondo": "Profondeur Date 40",
  "lorenzo-pagani-foudroyant": "Pacifique Chronograph 42",
  "lorenzo-pagani-cardinale": "Aviateur Automatic 44",
  "lorenzo-pagani-regina": "Terre & Mer Automatic",
  "lorenzo-pagani-laguna": "Marée Hydro Diver 42",
  "lorenzo-pagani-equateur": "Méridien GMT NH34",
  "lorenzo-pagani-meridienne": "Expédition GMT 42 Acier",
  "lorenzo-pagani-tramontane": "Héritage GMT",
  "lorenzo-pagani-avignon": "Océanique Planétaire 43",
  "lorenzo-pagani-allure": "Octave Chronograph",
  "lorenzo-pagani-gabbiano": "Marée Professional 43",
  "lorenzo-pagani-marenostro": "Aviateur Automatic 40",
  "lorenzo-pagani-zephyr-marin": "Aviateur Instrument 40",
  "lorenzo-pagani-sillon": "Méridien Left Crown GMT",
  "lorenzo-pagani-pole-position": "Lunaire Chronograph 42",
  "lorenzo-pagani-vitesse": "Vélocité Chronograph",
  "lorenzo-pagani-tresor": "Profondeur Bicolore 43",
  "lorenzo-pagani-mansart": "Profondeur Classic Date 40",
  "lorenzo-pagani-leviathan": "Pacifique Tool Automatic 45",
  "lorenzo-pagani-nereide": "Atelier Glacier Automatic 40",
  "lorenzo-pagani-cormoran": "Profondeur Deep Automatic 44",
  "lorenzo-pagani-mistral": "Méridien Crown GMT",
  "lorenzo-pagani-bathyale": "Éclat Automatic 40",
  "lorenzo-pagani-compteur": "Vélocité Panda Chronograph 40",
  "lorenzo-pagani-courant": "Aviateur Date Automatic 40",
  "lorenzo-pagani-rivage": "Aviateur Date 41",
  "lorenzo-pagani-or-royal": "Profondeur Bicolore Date 40",
  "lorenzo-pagani-transat": "Expédition GMT 42",
  "lorenzo-pagani-couronnement": "Octave Automatic",
  "lorenzo-pagani-murano": "Marée Aquatique 43",
  "lorenzo-pagani-sceau": "Vendôme Date 42",
  "lorenzo-pagani-asphalte": "Vélocité Panda Chronograph",
  "lorenzo-pagani-brandebourg": "Profondeur Classic 43",
  "lorenzo-pagani-verona": "Océanique Commander 42",
  "lorenzo-pagani-cavalier": "Régate Automatic 40",
  "lorenzo-pagani-horizon": "Méridien GMT"
};
  const modelCodes = {
  "lorenzo-pagani-velocite": "PD-1819",
  "lorenzo-pagani-magnolia": "PD-1825",
  "lorenzo-pagani-regent": "PD-YS034",
  "lorenzo-pagani-souverain": "PD-YS030",
  "lorenzo-pagani-circuit": "PD-YS032",
  "lorenzo-pagani-vendome": "PD-1780",
  "lorenzo-pagani-beaubourg": "PD-YS031",
  "lorenzo-pagani-concorde": "PD-YS029",
  "lorenzo-pagani-palatin": "PD-1821",
  "lorenzo-pagani-brasier": "PD-1822",
  "lorenzo-pagani-voyageur": "PD-1888",
  "lorenzo-pagani-belvedere": "PD-1820",
  "lorenzo-pagani-diademe": "PD-YS028",
  "lorenzo-pagani-monarque": "PD-YS022",
  "lorenzo-pagani-piston": "PD-1811",
  "lorenzo-pagani-sorbonne": "PD-1687",
  "lorenzo-pagani-noblesse": "PD-YS023",
  "lorenzo-pagani-rotonde": "PD-1772",
  "lorenzo-pagani-capitole": "PD-YS021",
  "lorenzo-pagani-montparnasse": "PD-1734",
  "lorenzo-pagani-florentine": "PD-YS027",
  "lorenzo-pagani-tempete": "PD-1816",
  "lorenzo-pagani-versailles": "PD-1818",
  "lorenzo-pagani-bellini": "PD-1725",
  "lorenzo-pagani-lutece": "PD-YS020",
  "lorenzo-pagani-saphir-royale": "PD-YS019",
  "lorenzo-pagani-doge": "PD-YS025",
  "lorenzo-pagani-prisma-course": "PD-1644-RAINBOW",
  "lorenzo-pagani-etoile": "PD-1793",
  "lorenzo-pagani-colonnade": "PD-1795",
  "lorenzo-pagani-maesta": "PD-1812",
  "lorenzo-pagani-sillage": "PD-1813",
  "lorenzo-pagani-carillon": "PD-1796",
  "lorenzo-pagani-clementine": "PD-1789",
  "lorenzo-pagani-fulminant": "PD-3307",
  "lorenzo-pagani-aristide": "PD-1791",
  "lorenzo-pagani-bourbon": "PD-1777",
  "lorenzo-pagani-sacre": "PD-YS017",
  "lorenzo-pagani-verdoyer": "PD-1701-GOLD-GREEN",
  "lorenzo-pagani-palazzo": "PD-YS018",
  "lorenzo-pagani-abysse": "PD-1691",
  "lorenzo-pagani-maree": "PD-1755",
  "lorenzo-pagani-apogee": "PD-YS015",
  "lorenzo-pagani-fuseau": "PD-1792-GMT",
  "lorenzo-pagani-apex": "PD-2720K",
  "lorenzo-pagani-saphira": "PD-1776",
  "lorenzo-pagani-cadence": "PD-1708",
  "lorenzo-pagani-solferino": "PD-1759",
  "lorenzo-pagani-citadelle": "PD-2770",
  "lorenzo-pagani-emeraude": "PD-1786",
  "lorenzo-pagani-boreal": "PD-1788-GMT-SEIKO-NH34",
  "lorenzo-pagani-medicis": "PD-1790",
  "lorenzo-pagani-aragon": "PD-YS014",
  "lorenzo-pagani-pavillon": "PD-1654",
  "lorenzo-pagani-brasero": "PD-1775",
  "lorenzo-pagani-fougue": "PD-1782",
  "lorenzo-pagani-sprint": "PD-1781",
  "lorenzo-pagani-trajectoire": "PD-1766",
  "lorenzo-pagani-recif": "PD-1784",
  "lorenzo-pagani-chatelet": "PD-1783",
  "lorenzo-pagani-richelieu": "PD-1778",
  "lorenzo-pagani-turenne": "PD-1732",
  "lorenzo-pagani-lagon": "PD-1697",
  "lorenzo-pagani-diamantine": "PD-YS013",
  "lorenzo-pagani-etincelle": "PD-YS011",
  "lorenzo-pagani-saint-honore": "PD-YS012",
  "lorenzo-pagani-regalia": "PD-1671-V2",
  "lorenzo-pagani-tropique": "PD-1762",
  "lorenzo-pagani-couronne": "PD-1651-ROSE-GOLD",
  "lorenzo-pagani-tourmaline": "PD-1773",
  "lorenzo-pagani-aurelio": "PD-YS010",
  "lorenzo-pagani-ondine": "PD-1767",
  "lorenzo-pagani-caspienne": "PD-1674",
  "lorenzo-pagani-bolide": "PD-YS008",
  "lorenzo-pagani-sirene": "PD-YN009",
  "lorenzo-pagani-adriano": "PD-YS007",
  "lorenzo-pagani-galliera": "PD-1726",
  "lorenzo-pagani-profond": "PD-1764",
  "lorenzo-pagani-triton": "PD-1736",
  "lorenzo-pagani-esplanade": "PD-1729",
  "lorenzo-pagani-noctis-course": "PD-1644-BLACK",
  "lorenzo-pagani-dore-circuit": "PD-1644-GOLD",
  "lorenzo-pagani-granducale": "PD-1738",
  "lorenzo-pagani-cordoban": "PD-1719",
  "lorenzo-pagani-tachymetre": "PD-1761",
  "lorenzo-pagani-vincennes": "PD-1753",
  "lorenzo-pagani-elan": "PAGANI-DESIGN-1718",
  "lorenzo-pagani-ressac": "PAGANI-DESIGN-1722",
  "lorenzo-pagani-seraphine": "PAGANI-DESIGN-1723",
  "lorenzo-pagani-corallo": "PAGANI-DESIGN-YS005",
  "lorenzo-pagani-lavande": "PAGANI-DESIGN-1717",
  "lorenzo-pagani-topaze": "PD-1727",
  "lorenzo-pagani-capodimonte": "PD-1733",
  "lorenzo-pagani-marquise": "PD-1728",
  "lorenzo-pagani-hortensia": "PD-1752",
  "lorenzo-pagani-zenith": "PD-1758-GMT-3",
  "lorenzo-pagani-cartographe": "PD-1758-GMT",
  "lorenzo-pagani-orchidee": "PD-1751",
  "lorenzo-pagani-mesange": "PD-1716",
  "lorenzo-pagani-brindille": "PD-1737",
  "lorenzo-pagani-nacre": "PD-1730",
  "lorenzo-pagani-clarte": "PD-1802L",
  "lorenzo-pagani-frontenac": "PD-1638",
  "lorenzo-pagani-onda": "PAGANI-DESIGN-1689",
  "lorenzo-pagani-maestrale": "PAGANI-DESIGN-1685",
  "lorenzo-pagani-imperial": "PAGANI-DESIGN-1671",
  "lorenzo-pagani-concertino": "PAGANI-DESIGN-1653",
  "lorenzo-pagani-profondo": "PAGANI-DESIGN-1694",
  "lorenzo-pagani-foudroyant": "PAGANI-DESIGN-1711",
  "lorenzo-pagani-cardinale": "PAGANI-DESIGN-1649",
  "lorenzo-pagani-regina": "PAGANI-DESIGN-1688",
  "lorenzo-pagani-laguna": "PAGANI-DESIGN-1702",
  "lorenzo-pagani-equateur": "PD-1662-NH34-GMT",
  "lorenzo-pagani-meridienne": "PD-1693",
  "lorenzo-pagani-tramontane": "PD-1706",
  "lorenzo-pagani-avignon": "PD-1679",
  "lorenzo-pagani-allure": "PD-1707",
  "lorenzo-pagani-gabbiano": "PD-1668A",
  "lorenzo-pagani-marenostro": "PD-1692-II",
  "lorenzo-pagani-zephyr-marin": "AIR-KING",
  "lorenzo-pagani-sillon": "PD-1662-GMT-I-BLACK-GREEN",
  "lorenzo-pagani-pole-position": "PAGANI-DESIGN-1701",
  "lorenzo-pagani-vitesse": "PD-1664",
  "lorenzo-pagani-tresor": "PD-1639-GOLD-BLUE",
  "lorenzo-pagani-mansart": "PD-1661",
  "lorenzo-pagani-leviathan": "PD-1695",
  "lorenzo-pagani-nereide": "PD-1715",
  "lorenzo-pagani-cormoran": "PD-1680",
  "lorenzo-pagani-mistral": "EXPLORER-GMT-PD-1662-ORO",
  "lorenzo-pagani-bathyale": "PD-1690",
  "lorenzo-pagani-compteur": "PD-1676",
  "lorenzo-pagani-courant": "PD-1692",
  "lorenzo-pagani-rivage": "PD-YS003",
  "lorenzo-pagani-or-royal": "1661",
  "lorenzo-pagani-transat": "PAGANI-DESIGN-GMT-2",
  "lorenzo-pagani-couronnement": "PAGANI-DESIGN-ROYAL-OAK",
  "lorenzo-pagani-murano": "PD-1668-AQUARACER",
  "lorenzo-pagani-sceau": "1645",
  "lorenzo-pagani-asphalte": "PD-1644",
  "lorenzo-pagani-brandebourg": "1639",
  "lorenzo-pagani-verona": "PAGANI-DESIGN-1667",
  "lorenzo-pagani-cavalier": "PD-1651",
  "lorenzo-pagani-horizon": "EXPLORERGMT"
};
  const topSellerHandles = [
  "lorenzo-pagani-horizon",
  "lorenzo-pagani-tropique",
  "lorenzo-pagani-pole-position",
  "lorenzo-pagani-equateur",
  "lorenzo-pagani-voyageur",
  "lorenzo-pagani-vitesse",
  "lorenzo-pagani-couronnement",
  "lorenzo-pagani-transat"
];

  function applyCollectionNames() {
    document.querySelectorAll("card-product[data-handle]").forEach((card) => {
      const handle = card.dataset.handle || "";
      const heading = card.querySelector(".card-product__title");
      if (!heading || !preferredNames[handle]) return;

      heading.textContent = preferredNames[handle];
      heading.dataset.lpPreview = "true";

      let code = card.querySelector(".lp-model-code");
      if (!code) {
        code = document.createElement("span");
        code.className = "lp-model-code";
        heading.insertAdjacentElement("afterend", code);
      }
      code.textContent = modelCodes[handle] || "";
    });
  }

  function applyHomepageNames() {
    document.querySelectorAll(".ap-product-card").forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const heading = card.querySelector(".ap-product-title");
      if (!link || !heading) return;

      const match = link.getAttribute("href")?.match(/\/products\/([^?#/]+)/);
      const handle = match?.[1] || "";
      if (!preferredNames[handle]) return;

      heading.textContent = preferredNames[handle];
      heading.dataset.lpPreview = "true";

      let code = card.querySelector(".lp-model-code");
      if (!code) {
        code = document.createElement("span");
        code.className = "lp-model-code";
        heading.insertAdjacentElement("afterend", code);
      }
      code.textContent = modelCodes[handle] || "";
    });
  }

  function enhanceTrustBanner() {
    const banner = document.querySelector(".vp-trust-bar");
    if (!banner || banner.classList.contains("lp-trust-banner")) return;

    const items = document.createElement("div");
    items.className = "lp-trust-items";
    ["Free Shipping", "2-Year Warranty", "30-Day Returns"].forEach((label) => {
      const item = document.createElement("span");
      item.className = "lp-trust-item";
      const icon = document.createElement("span");
      icon.className = "lp-trust-icon";
      icon.textContent = "✓";
      const text = document.createElement("span");
      text.textContent = label;
      item.append(icon, text);
      items.append(item);
    });

    banner.replaceChildren(items);
    banner.classList.add("lp-trust-banner");
  }

  function reorderTopSellers() {
    const grid = document.querySelector("#product-grid");
    if (!grid || !grid.querySelector(":scope > card-product")) return;

    const cards = [...grid.querySelectorAll(":scope > card-product")];
    const byHandle = new Map(cards.map((card) => [card.dataset.handle, card]));
    const promoted = topSellerHandles.map((handle) => byHandle.get(handle)).filter(Boolean);
    const promotedSet = new Set(promoted);
    grid.append(...promoted, ...cards.filter((card) => !promotedSet.has(card)));
  }

  function useCompactMobileHero() {
    if (!matchMedia("(max-width: 749px)").matches) return;
    const hero = document.querySelector('[id$="__hero_banner_NhWFPN"]');
    const desktop = hero?.querySelector(".hero__media.small-hide img");
    const mobile = hero?.querySelector(".hero__media.small-up-hide img");
    if (!desktop || !mobile) return;

    const desktopSource = desktop.getAttribute("src") || desktop.src;
    mobile.removeAttribute("srcset");
    mobile.removeAttribute("sizes");
    mobile.src = desktopSource.replace(/width=\d+/, "width=960");
  }

  function applyPreview() {
    useCompactMobileHero();
    reorderTopSellers();
    // Keep the native Shopify PD product titles.
    enhanceTrustBanner();
  }

  document.addEventListener("DOMContentLoaded", () => {
    applyPreview();
  });
})();
